import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectors as commandSelectors } from '../../../../boards/Mat/Commands/commandsSlice';
import { getBoardSlice } from '../../../../boards/boardSlices';
import { selectActiveBoard } from '../../../RightMenu/rightMenuSlice';
import { useHashUrl } from '../useHashUrl';
import { selectDisks } from '../../../../../Common/disks/disksSlice';
import useCoordinates from '../../../../DiskSection/DisksContainer/CoordinatesContainer/useCoordinates';
import createMatDocument from './pdf/createMatDocument';
import { MAT_CONFIGS } from '../../../../boards/matConfigs';

const useExport = (emptyBoardExport) => {
    const activeBoard = useSelector(selectActiveBoard);
    const [hash, link] = useHashUrl();
    const coordinates = useCoordinates({ allTypesOfDisk: true });
    const { selectors } = getBoardSlice(activeBoard);
    const board = useSelector(selectors.selectBoard);
    const commands = useSelector(commandSelectors.selectBoard);
    const disks = useSelector(selectDisks);
    const { t, i18n } = useTranslation();

    const parseDiskIdToPath = (id, disks) => {
        const disk = disks.find((disk) => disk.id === id);
        if (disk) {
            return `${process.env.REACT_APP_CND_URL}/${disk?.path.slice(0, -3)}png`;
        }

        return '';
    };

    const parsedBoard = board.map((row) => row.map((diskId) => parseDiskIdToPath(diskId, disks)));
    const parsedCommands = commands.map((row) => row.map((diskId) => parseDiskIdToPath(diskId, disks)));
    const parsedCoordinates = coordinates.map((coordinate) => (
        {
            ...coordinate,
            path: parseDiskIdToPath(coordinate.id, disks),
        }
    ));

    const documentData = {
        t,
        language: i18n.language,
        hash,
        link,
        board: parsedBoard,
        commands: parsedCommands,
        coordinates: parsedCoordinates,
        activeBoard,
    };

    const [cols, rows] = MAT_CONFIGS[activeBoard].gridSize;
    const defaultBoard = [...new Array(rows).fill([...new Array(cols).fill('')])];
    const emptyDocumentData = {
        t,
        language: i18n.language,
        hash,
        link,
        board: defaultBoard,
        commands: [...new Array(2).fill([...new Array(10).fill('')])],
        coordinates: parsedCoordinates,
        activeBoard,
    };

    return () => createMatDocument(emptyBoardExport ? emptyDocumentData : documentData);
};

export default useExport;
